var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showFilter":false,"showSearch":false,"showExportation":false},on:{"addEvent":function($event){return _vm.$router.push({name: 'addCategory'})}}},[_vm._v("اقسام الأخبار")]),_c('main-table',{attrs:{"fields":_vm.fields,"baseURL":_vm.VUE_APP_WEBSITE_LINK,"list_url":'admin/categories'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }